export enum Commands {
  Edit = 'Edit',
  Duplicate = 'Duplicate',
  Delete = 'Delete',
  Deactivate = 'Deactivate',
  Active = 'Activate',
  Slack_Activity = 'Slack Activity',
  Deploy = 'Deploy',
  Order = 'Set order of execution',
  Integration_Activity = 'Integration Activity',
  Version_History = 'Version History',
  MsTeams_Activity = 'MS Teams Activity',
  Simulate_Assignment = 'Simulate Assignment',
}
